import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'


import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'


//layout
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import ChartTypeLine from './ChartTypeLine'
import ChartTypeBars from './ChartTypeBars'
import ChartTypeBars3D from './ChartTypeBars3D'
import ChartTypeColumn from './ChartTypeColumn'
import ChartTypeColumn3D from './ChartTypeColumn3D'
import ChartTypeFunnel from './ChartTypeFunnel'
import ChartTypeGouge from './ChartTypeGouge'

const useStyles = (theme) => ({
  root:{
    marginTop: theme.spacing(4),
  },
});

class ChartManager  extends Component {

  constructor(props) {
    super(props)

    this.state = {
      chartType: props.chartType,
    }
  }

  handleChartType = (event) => {
    this.setState({chartType: event.target.value})
    this.props.onEventChangeChartType(event)
  }

  handleEventOnChange = (item, dropResult) => {
    console.log("handleEventOnChange", item)
    console.log("handleEventOnChange", dropResult)
  }

  handleEventOnDelete = (item, dropResult) => {
    console.log("handleEventOnChange", item)
    console.log("handleEventOnChange", dropResult)
  }
  handleEventOnColor = (item, dropResult) => {
    console.log("handleEventOnChange", item)
    console.log("handleEventOnChange", dropResult)
  }
  

  render (){

    const { classes} = this.props;
  
    return (
        <div className={classes.root} >
          <DndProvider backend={HTML5Backend}>
            
            <InputLabel>Tipos de gráficos</InputLabel>
            <Select value={this.state.chartType} onChange={this.handleChartType} >              
              <MenuItem value="" >Selecione</MenuItem>                                      
              <MenuItem value="line" >Line</MenuItem>
              <MenuItem value="bar" >Barra</MenuItem>
              <MenuItem value="bar3d" >Barra 3D</MenuItem>
              <MenuItem value="column" >Colunas</MenuItem>
              <MenuItem value="column3d" >Coluna 3D</MenuItem>                                                    
              <MenuItem value="funnel" >Funil</MenuItem>                                                    
              <MenuItem value="gouge" >Gouge</MenuItem>                                                                  
            </Select> 
            

            {this.state.chartType === "line"?(
                <ChartTypeLine 
                  {...this.props} 
                  report={this.props.report}
                  dataset={this.props.dataset}
                  onEventOption={this.props.onEventOption} 
                  eventoOnChange={this.handleEventOnChange}                 
                  eventOnDelete={this.handleEventOnDelete}                 
                  eventOnColor={this.handleEvehandleEventOnColorntOnDelete}                 
                  onEnvetManagerOptions={this.props.onEnvetManagerOptions}
                  managerOptions={this.props.managerOptions}                  
                />
            ):this.state.chartType === "bar"?(
              <ChartTypeBars 
                {...this.props} 
                report={this.props.report}
                managerOptions={this.props.managerOptions}
                dataset={this.props.dataset}
                onEventOption={this.props.onEventOption} 
                eventoOnChange={this.handleEventOnChange}                 
                eventOnDelete={this.handleEventOnDelete}                 
                onEnvetManagerOptions={this.props.onEnvetManagerOptions}                
                eventOnColor={this.handleEvehandleEventOnColorntOnDelete}                 
                                
              />
            ):this.state.chartType === "bar3d"?(
                <ChartTypeBars3D 
                  {...this.props} 
                  report={this.props.report}
                  dataset={this.props.dataset}
                  managerOptions={this.props.managerOptions}
                  onEventOption={this.props.onEventOption} 
                  eventoOnChange={this.handleEventOnChange}                 
                  eventOnDelete={this.handleEventOnDelete}                 
                  eventOnColor={this.handleEvehandleEventOnColorntOnDelete}
                  onEnvetManagerOptions={this.props.onEnvetManagerOptions}
                />
            ):this.state.chartType === "column"?(
                <ChartTypeColumn 
                  {...this.props} 
                  report={this.props.report}
                  dataset={this.props.dataset}
                  managerOptions={this.props.managerOptions}
                  onEventOption={this.props.onEventOption} 
                  eventoOnChange={this.handleEventOnChange}                 
                  eventOnDelete={this.handleEventOnDelete}                 
                  eventOnColor={this.handleEvehandleEventOnColorntOnDelete}
                  onEnvetManagerOptions={this.props.onEnvetManagerOptions}
                />
            ):this.state.chartType === "column3d"?(
                <ChartTypeColumn3D 
                  {...this.props} 
                  report={this.props.report}
                  dataset={this.props.dataset}
                  managerOptions={this.props.managerOptions}
                  onEventOption={this.props.onEventOption} 
                  eventoOnChange={this.handleEventOnChange}                 
                  eventOnDelete={this.handleEventOnDelete}                 
                  eventOnColor={this.handleEvehandleEventOnColorntOnDelete}
                  onEnvetManagerOptions={this.props.onEnvetManagerOptions}
                />
            ):this.state.chartType === "funnel"?(                     
              <ChartTypeFunnel
                {...this.props} 
                report={this.props.report}
                dataset={this.props.dataset}
                managerOptions={this.props.managerOptions}
                onEventOption={this.props.onEventOption} 
                eventoOnChange={this.handleEventOnChange}                 
                eventOnDelete={this.handleEventOnDelete}                 
                eventOnColor={this.handleEvehandleEventOnColorntOnDelete}
                onEnvetManagerOptions={this.props.onEnvetManagerOptions}
              />
                
            ):this.state.chartType === "gouge"?(
                <div>
                <h1>Ahhhh Fernandinho! Este também não está pronto</h1>
                <h3>Segue uma amostra do que é</h3>
                  <ChartTypeGouge/>
                </div>
            ):''}
          </DndProvider>  
        </div>
        
      )
  }
}

export default withStyles(useStyles)(ChartManager)